import configs from "config";
import { eventsConstant } from "../constants";
import ReactGA from "react-ga4";
export const EventNames = eventsConstant;
export const EventManager = {
  //initialise
  initialise: () => {
    ReactGA.initialize("G-Z7EFW2MHRM");
  },

  // send events to clever track
  send: (eventName = "", eventParams: any = {}) => {
    ReactGA.event(eventName, eventParams && { ...eventParams });
  },
};
